import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import * as $ from 'jquery';
@Component({
  selector: 'content-video',
  templateUrl: './content-video.component.html',
  styleUrls: ['./content-video.component.scss']
})
export class ContentVideoComponent implements OnInit {
  @Input() datoPublic?: any;
  idiomaActual:any;
    constructor(private translateSrv: TranslateService,) {
      this.idiomaActual = this.translateSrv.currentLang;
      this.translateSrv.onLangChange.subscribe(() => {
        this.idiomaActual = this.translateSrv.currentLang;
        console.log(this.idiomaActual);
      });
    }

  ngOnInit(): void {

    console.log(this.datoPublic);

  }

}
